import { render } from "./DepEdPersonnelDialog.vue?vue&type=template&id=6839ef14"
import script from "./DepEdPersonnelDialog.vue?vue&type=script&lang=js"
export * from "./DepEdPersonnelDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__